import script from "./RadarChart.vue?vue&type=script&setup=true&lang=js"
export * from "./RadarChart.vue?vue&type=script&setup=true&lang=js"

import "./RadarChart.vue?vue&type=style&index=0&id=cb444d04&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cb444d04"]])

export default __exports__